import api from './axios';
import { Product } from '../types';

export const productsApi = {
  getAll: (params?: { search?: string; categoryId?: number }) =>
    api.get<Product[]>('/products', { params }),

  getById: (id: number) =>
    api.get<Product>(`/products/${id}`),

  create: (data: Partial<Product>) =>
    api.post<Product>('/products', data),

  update: (id: number, data: Partial<Product>) =>
    api.put<Product>(`/products/${id}`, data),

  delete: (id: number) =>
    api.delete(`/products/${id}`),

  getLowStock: () =>
    api.get<Product[]>('/products/low-stock'),
};
